export const aboutData = {
    title: "Who I am",
    description1: "Hi, my name is Aftab Ahmed. I live in Pune and work as a Full-Stack Web Developer.",
    description2: "I'm passionate about technology and how it can improve people's lives. I learned the basics of web development while studying and have been working towards a career in this field ever since.",
    image: 1
}
